import {
    MIGRATE_SET_BRAND_SIGNIN_TOKEN,
    MIGRATE_SET_SHOW_VERIFICATION_SENT,
    MIGRATE_SET_SHOW_CONGRATULATION,
    MIGRATE_SET_STATUS_CODE
} from '../actions/ActionTypes';

/**
 * Empty initial state so we can clear all form data the first times forms are loaded
 */
const initialState = {
    brandSignInToken: null,
    showVerificationSent: false,
    showCongratulation: false,
    userStatus: null,
    guest: null,
    forceEmailVerify: null,
    sflySignupToken: null,
    mergedEmail: null
};

export function migrateReducer(state = initialState, action) {

    switch(action.type) {

        case MIGRATE_SET_BRAND_SIGNIN_TOKEN:
            return Object.assign({}, state, {brandSignInToken: action.brandSignInToken});

        case MIGRATE_SET_SHOW_VERIFICATION_SENT:
            return Object.assign({}, state, {showVerificationSent: action.showVerificationSent});

        case 'MIGRATE_SET_MERGED_EMAIL':
            return Object.assign({}, state, {mergedEmail: action.mergedEmail});    
        
        case 'MIGRATE_RESET_MERGED_EMAIL':
            return Object.assign({}, state, {mergedEmail: ''});        
            
        case MIGRATE_SET_SHOW_CONGRATULATION:
            return Object.assign({}, state, { showCongratulation: action.showCongratulation });
        
        case 'SET_TOKEN':
                return Object.assign({}, state, { sflySignupToken: action.token });
                

        case MIGRATE_SET_STATUS_CODE:
            return Object.assign({}, state, {userStatus: action.userStatus, guest: action.guest, forceEmailVerify: action.forceEmailVerify});

        default:
            return state;

    }

}